import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { Updatepage } from './updatepage';

@NgModule({
  declarations: [
    Updatepage,
  ],
  imports: [
    IonicPageModule.forChild(Updatepage),
  ],
  exports: [
    Updatepage
  ]
})
export class UpdatepageModule {}



// WEBPACK FOOTER //
// ./src/pages/updatepage/updatepage.module.ts